import { CMS_API_URL } from 'utils/endpoints';

export function buildApiUrl(path: string) {
  return `${CMS_API_URL}/api/page-data/${path}`;
}

export function buildApiFallbackUrl(path: string) {
  return `${CMS_API_URL}/api/fallback/${path}`;
}

export function buildDraftApiUrl(path: string) {
  return `${CMS_API_URL}/api${path}`;
}
